import React, {
	Component,
	PropTypes
} from 'react';
import render from "react-dom";
import {
	Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import  {bumpUrl}from '../../../path.config'
import bumpService from 'SERVICES/purifier/bump/bumpService'
import SearchInput from 'CONFIG/component/search/searchInput'
import Tip from 'CONFIG/component/tip'
import ModalDel from 'CONFIG/component/ModalDel'
import BoxHeader from "CONFIG/component/boxHeader"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import {language,pageOption} from 'UTIL/common'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
export default class PframeworkIndex extends Component {
	constructor(props) {
		super(props);
		this.delList = this.delList;
		this.onPageChange = this.onPageChange.bind(this);
		this.handle = this.handle.bind(this);
		this.del = this.del.bind(this);
		this.state = {
			data: [],
			pageSize: 10,
			page: 1,
			total: 0,
			delRow: {},
			url: bumpUrl,
            protocolCheckTypes:{},
		}

	};
    componentDidMount() {
        this.onPageChange(this.state.page,this.state.pageSize)
    }
	handle(cell, row) {
		var edit_url = "/config/pframework/pframeworkEdit/" + row.id;
		return <div>
				<Link to={edit_url}  className="btn btn-info btn-sm">{language()['edit']}</Link>&nbsp;&nbsp;
				<a  className="btn btn-danger btn-sm" data-target="#delModal" data-toggle="modal"
					onClick={this.delList.bind(this,row.id,row.proName)}>{language()['delete']}</a>
			</div>;
	};
	delList(id, name, e) {
		const delList = {
			"id": id,
			"name": name
		};
		this.setState({
			delRow: delList,
		})
	}
	del() {
		const _this = this;
		const id =this.state.delRow.id;
		bumpService.pframeworkDelete(id).then(data=>{
            _this.onPageChange(1,this.state.pageSize);
            if (data.code == 8001) {
                $("#success_msg").text(data.msg);
                $("#success_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#success_tip").addClass("hidden");
                }, 3000);
            } else {
                $("#error_msg").text(data.msg);
                $("#error_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
		})
	}

	searchHandle() {
        this.onPageChange(1,this.state.pageSize);
	}
	onPageChange(page, sizePerPage, e) {
        var proName = $("#proName").val();
        const arr = {
            "search": proName,
            "page": page,
            "pageSize": sizePerPage
        };
        var data = JSON.stringify(arr);
        bumpService.pframeworkList({data}).then(body=>{
        	console.log(body)
            const json = body.data;
            const total = json.frameworkList.total;
            const list = json.frameworkList.records;
            this.setState({
                data: list,
				page : page,
				pageSize : sizePerPage,
                total: total,
                protocolCheckTypes:json.protocolCheckTypes
            });
		});
	}
    nameHanle(cell,row){
    return this.state.protocolCheckTypes[row.proCheckName];
	}
    reset(){
        $("#proName").val('');
        this.onPageChange(1,10)
    }
    dvcType(cell,row){
    	return row.dvctype.name;
	}
	render() {
		let options = pageOption(this.state.page,this.state.pageSize);
		options['onPageChange'] = this.onPageChange.bind(this);
		var create_url = "/config/pframework/pframeworkCreate";
		return (
			<div >
				<section className="content-header " >
					 <h1> {language()['BasicConfiguration']} <small>{language()['proDefinition']}</small> </h1>
				</section>
				 <section className="content" >
					 <div className="box box-primary color-palette-box">
						 <div className="box-header with-border">
							 <i className="fa fa-list"></i>
							 <h3 className="box-title">{language()['proDefinitionList']}</h3>
							 <div style={{marginRight:"10px",float:"right"}}>
								  <Link to={create_url}  className="btn btn-success btn-md"  >
										<i className="fa fa-plus-circle"></i> {language()['add']}
								  </Link>
							 </div>
						 </div>
						 <div className="box-body">
							 <Tip ids=""/>
							 <div className="title-box">
								 <div className="clearfix">
									 <LongSearchInput id="proName" name={language()['proName']}/>
									 <button type="button" className="btn btn-info" onClick={this.searchHandle.bind(this)}>{language()['query']}</button>

									 &nbsp;&nbsp;<button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>{language()['resetting']}</button>
								 </div>
							 </div>
							 <div >
								 <BootstrapTable data = {this.state.data} remote={true} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options}  >
									 <TableHeaderColumn isKey dataField='id' hidden={true}>id </TableHeaderColumn>
									 <TableHeaderColumn  dataFormat={this.dvcType.bind(this)} width="200">{language()['ModelCategory']}</TableHeaderColumn>
									 <TableHeaderColumn  dataField='proName'  width="200">{language()['proName']} </TableHeaderColumn>
									 <TableHeaderColumn  dataFormat={this.handle}  columnClassName="td-mid"  width="200">{language()['operation']}</TableHeaderColumn>
								 </BootstrapTable>
							 </div>
						 </div>
					 </div>
				 </section>
				<ModalDel id="delModal" delModSure={this.del} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/bump/config/pframework/pframeworkIndex.js